module.exports = __webpack_public_path__ + "img/OVO_80X30.1c7abef0.png";